module.exports = __webpack_public_path__ + "img/shopping-bag-2-fill.f13e26ff.svg";